export default "__VITE_ASSET__BqWzRxOi__"